var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Emit, Inject, Prop, Vue, } from "vue-property-decorator";
import ArticleNameElement from "../../components/articleattributes/articlenameelement.vue";
import TubeElement from "../../components/articleattributes/tubeelement.vue";
import TubeLengthElement from "../../components/articleattributes/tubelengthelement.vue";
import { isString, isNumber, } from "../utilities/wsi4_typeguards";
let UserDefinedTube = class UserDefinedTube extends Vue {
    constructor() {
        super(...arguments);
        this.dimX = 100.;
        this.name = "";
        this.tubeId = "";
    }
    close() { }
    validInput(valid) { return valid; }
    transferData() {
        return {
            tubeId: this.tubeId,
            dimX: this.dimX,
            name: this.name,
        };
    }
    updateSvg() {
        const s = this.$el.querySelector(".part-creation-svg");
        if (s === undefined || s === null) {
            throw Error("Selector '.part-creation-svg' does not match");
        }
        for (const child of s.children) {
            s.removeChild(child);
        }
        const dp = new DOMParser();
        const tube = this.tube;
        if (tube === undefined) {
            return;
        }
        const tubeProfile = this.shopConfig.tubeProfiles.find(t => t.identifier === tube.tubeProfileId);
        if (tubeProfile === undefined) {
            throw Error("Missing tube profile.");
        }
        const svgElement = dp.parseFromString(tubeProfile.svg, "image/svg+xml").documentElement;
        s.appendChild(svgElement);
    }
    updateData() {
        if (this.valid) {
            this.updateSvg();
            this.transferData();
        }
        this.validInput(this.valid);
    }
    setName(name) {
        if (!isString(name)) {
            this.name = "";
        }
        else {
            this.name = name;
        }
        this.updateData();
    }
    setDimX(t) {
        this.dimX = t;
        this.updateData();
    }
    setTube(tubeId) {
        if (!isString(tubeId)) {
            throw Error("Wrong type.");
        }
        this.tubeId = tubeId;
        this.updateData();
    }
    get tube() {
        return this.shopConfig.tubes.find(t => this.tubeId === t.identifier);
    }
    get nameValid() {
        return this.name !== "";
    }
    get tubeIdValid() {
        return this.tube !== undefined;
    }
    get maximalDimX() {
        const t = this.shopConfig.tubes.find(t => t.identifier === this.tubeId);
        return t === undefined ? 0. : t.dimX;
    }
    get dimXValid() {
        return isNumber(this.dimX) && this.dimX > 0. && this.dimX < this.maximalDimX;
    }
    get valid() {
        return this.nameValid && this.tubeIdValid && this.dimXValid;
    }
    mounted() {
        if (this.shopConfig.tubes.length === 0) {
            throw Error("Missing tubes");
        }
        this.tubeId = this.shopConfig.tubes[0].identifier;
        this.name = this.i18n.t("article") + "_1";
        this.dimX = this.maximalDimX * 0.5;
        this.updateData();
    }
};
__decorate([
    Prop({ required: true })
], UserDefinedTube.prototype, "shopConfig", void 0);
__decorate([
    Inject()
], UserDefinedTube.prototype, "i18n", void 0);
__decorate([
    Emit()
], UserDefinedTube.prototype, "close", null);
__decorate([
    Emit()
], UserDefinedTube.prototype, "validInput", null);
__decorate([
    Emit()
], UserDefinedTube.prototype, "transferData", null);
UserDefinedTube = __decorate([
    Component({
        components: {
            ArticleNameElement,
            TubeElement,
            TubeLengthElement,
        },
        name: "UserDefinedTube",
    })
], UserDefinedTube);
export default UserDefinedTube;
